
export default function Footer() {
  return (
    <footer className="relative bg-[#111111] border-t border-[#00E5FF]/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-12 mb-8 sm:mb-12">
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/39d6fbca-b681-4c48-84eb-ab94b5a74e78.png"
              alt="EUREKA"
              className="h-10 sm:h-12 mb-4 sm:mb-6"
            />
            <p
              className="text-[#C0C7CF] text-xs sm:text-sm leading-relaxed"
              style={{ fontFamily: "Inter, sans-serif" }}
            >
              Przedsiębiorstwo Wielobranżowe EUREKA<br />
              Zabłotce 146<br />
              38-500 Sanok<br />
              <a
                href="tel:+48600978050"
                className="text-[#00E5FF] hover:underline cursor-pointer"
              >
                +48 600 978 050
              </a>
            </p>
          </div>

          <div>
            <h4
              className="text-white text-sm sm:text-lg font-bold mb-4 sm:mb-6"
              style={{ fontFamily: "Orbitron, sans-serif" }}
            >
              Kierownictwo
            </h4>
            <div
              className="space-y-3 sm:space-y-4 text-[#C0C7CF] text-xs sm:text-sm"
              style={{ fontFamily: "Inter, sans-serif" }}
            >
              <div>
                <strong className="text-white">Janusz Gładysz</strong> - właściciel
                <br />
                tel.{" "}
                <a
                  href="tel:+48600978050"
                  className="text-[#00E5FF] hover:underline cursor-pointer"
                >
                  +48 600 978 050
                </a>
                <br />
                e-mail:{" "}
                <a
                  href="mailto:jgladysz@eureka.sanok.pl"
                  className="text-[#00E5FF] hover:underline cursor-pointer"
                >
                  jgladysz@eureka.sanok.pl
                </a>
              </div>
              <div>
                <strong className="text-white">Konrad Komarski</strong> - kierownik
                produkcji
                <br />
                tel.{" "}
                <a
                  href="tel:+48790788033"
                  className="text-[#00E5FF] hover:underline cursor-pointer"
                >
                  +48 790 788 033
                </a>
                <br />
                e-mail:{" "}
                <a
                  href="mailto:kkomarski@eureka.sanok.pl"
                  className="text-[#00E5FF] hover:underline cursor-pointer"
                >
                  kkomarski@eureka.sanok.pl
                </a>
              </div>
            </div>
          </div>

          <div className="sm:col-span-2 lg:col-span-1">
            <h4
              className="text-white text-sm sm:text-lg font-bold mb-4 sm:mb-6"
              style={{ fontFamily: "Orbitron, sans-serif" }}
            >
              Nawigacja
            </h4>
            <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-1 gap-2 sm:gap-3">
              <a
                href="/"
                className="block text-[#C0C7CF] hover:text-[#00E5FF] transition-colors duration-300 text-xs sm:text-sm cursor-pointer"
                style={{ fontFamily: "Inter, sans-serif" }}
              >
                Home
              </a>
              <a
                href="/o-firmie"
                className="block text-[#C0C7CF] hover:text-[#00E5FF] transition-colors duration-300 text-xs sm:text-sm cursor-pointer"
                style={{ fontFamily: "Inter, sans-serif" }}
              >
                O Firmie
              </a>
              <a
                href="/uslugi"
                className="block text-[#C0C7CF] hover:text-[#00E5FF] transition-colors duration-300 text-xs sm:text-sm cursor-pointer"
                style={{ fontFamily: "Inter, sans-serif" }}
              >
                Usługi
              </a>
              <a
                href="/realizacje"
                className="block text-[#C0C7CF] hover:text-[#00E5FF] transition-colors duration-300 text-xs sm:text-sm cursor-pointer"
                style={{ fontFamily: "Inter, sans-serif" }}
              >
                Realizacje
              </a>
              <a
                href="/kontakt"
                className="block text-[#C0C7CF] hover:text-[#00E5FF] transition-colors duration-300 text-xs sm:text-sm cursor-pointer"
                style={{ fontFamily: "Inter, sans-serif" }}
              >
                Kontakt
              </a>
              <a
                href="/projekty-ue"
                className="block text-[#C0C7CF] hover:text-[#00E5FF] transition-colors duration-300 text-xs sm:text-sm cursor-pointer"
                style={{ fontFamily: "Inter, sans-serif" }}
              >
                Projekty UE
              </a>
              <a
                href="/polityka-prywatnosci"
                className="block text-[#C0C7CF] hover:text-[#00E5FF] transition-colors duration-300 text-xs sm:text-sm cursor-pointer"
                style={{ fontFamily: "Inter, sans-serif" }}
              >
                Polityka Prywatności
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-[#00E5FF]/20 pt-6 sm:pt-8 flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4">
          <p
            className="text-[#C0C7CF] text-[10px] sm:text-sm text-center sm:text-left"
            style={{ fontFamily: "Inter, sans-serif" }}
          >
            © 2024 EUREKA. Wszystkie prawa zastrzeżone.
          </p>
          <div
            className="flex items-center gap-3 text-[10px] sm:text-sm text-[#C0C7CF]"
            style={{ fontFamily: "Inter, sans-serif" }}
          >
            <span>Created by Orsonet 2026</span>
            <span className="text-[#333]">|</span>
            <a
              href="https://readdy.ai/?ref=logo"
              rel="nofollow"
              className="hover:text-[#00E5FF] transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
